"use client";

import { t } from "@/lib/localization";
import { getBaseUrl } from "@/lib/getBaseUrl";
import { lomdaEmbedCode } from "@/lib/utils/lomdaV3/embedCode";
import { useLocale } from "@/hooks/useLocale";
import { lomdaLocaleOf } from "./useLomdaLocale";

export const useLomdaShareLinks = (
    lomdaId: string,
    name: string | null,
    language: string
) => {
    const { locale } = useLocale();
    const shareUrl = `${getBaseUrl()}/${locale}/public/lomda-v3/${lomdaId}`;
    // The iframe title is read to the learner, so it follows the lomda's language.
    const title =
        name ||
        t("lomda-v3-editor.preview.untitled-lomda", lomdaLocaleOf(language));

    return { shareUrl, embedCode: lomdaEmbedCode(shareUrl, title) };
};
